import { apiRequest } from './client'
import type { DocumentDetail, DocumentSummary, DocumentVersionEntry } from './types'

export const documentationApi = {
  list: (projectId: string) => apiRequest<{ data: DocumentSummary[] }>('/documentation', { query: { projectId } }),

  get: (id: string) => apiRequest<{ data: DocumentDetail }>(`/documentation/${id}`),

  create: (input: { projectId: string; title: string; category?: string; content?: string }) =>
    apiRequest<{ data: DocumentDetail }>('/documentation', { method: 'POST', body: input }),

  update: (id: string, input: Partial<{ title: string; category: string; content: string }>) =>
    apiRequest<{ data: DocumentDetail }>(`/documentation/${id}`, { method: 'PATCH', body: input }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/documentation/${id}`, { method: 'DELETE' }),

  listVersions: (id: string) => apiRequest<{ data: DocumentVersionEntry[] }>(`/documentation/${id}/versions`),

  getVersion: (id: string, versionId: string) => apiRequest<{ data: DocumentVersionEntry }>(`/documentation/${id}/versions/${versionId}`),

  setLinks: (id: string, targetDocumentIds: string[]) =>
    apiRequest<{ data: DocumentDetail }>(`/documentation/${id}/links`, { method: 'PATCH', body: { targetDocumentIds } }),

  setTasks: (id: string, taskIds: string[]) =>
    apiRequest<{ data: DocumentDetail }>(`/documentation/${id}/tasks`, { method: 'PATCH', body: { taskIds } }),
}
